export const ADMIN = "admin";
export const USER = "user";

export const AUTHORITY = {
  SUPER_ADMIN: "SuperAdmin",
  ADMIN: "Admin",
};
